import { ChemicalComponent } from '@/services/chemical-component'
import { Col, Modal, Row, Space } from 'antd'
import React, { memo, useState } from 'react'
import styles from './index.module.less'

interface ChemicalComponentDetailModalProps {
  trigger: JSX.Element
  component: ChemicalComponent.Modal
}

const ChemicalComponentDetailModal = memo((props: ChemicalComponentDetailModalProps) => {
  const { trigger, component } = props
  const [isOpen, setIsOpen] = useState(false)

  const showModal = () => {
    setIsOpen(true)
  }

  const handleOk = () => {
    setIsOpen(false)
  }

  const handleCancel = () => {
    setIsOpen(false)
  }

  return (<>
    <div onClick={showModal} style={{ cursor: 'pointer' }}>
      {trigger}
    </div>
    <Modal
      width={700}
      title={component.name ? `${component.name} Detail` : 'Component Detail'}
      footer={null}
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Row>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Name:</label>
            <div>{component.name || '-'}</div>
          </Space>
        </Col>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Formula:</label>
            <div>{component.formula || '-'}</div>
          </Space>
        </Col>
      </Row>
      <Row className='mt1'>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Molecular Weight:</label>
            <div>{component.mw || '-'}</div>
          </Space>
        </Col>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Critical Pressure:</label>
            <div>{component.pc || '-'}</div>
          </Space>
        </Col>
      </Row>
      <Row className='mt1'>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Critical Temperature:</label>
            <div>{component.tc || '-'}</div>
          </Space>
        </Col>
        <Col style={{ width: '50%' }}>
          <Space>
            <label className={styles.label}>Acentric Factor:</label>
            <div>{component.af || '-'}</div>
          </Space>
        </Col>
      </Row>
      <Row className='mt1'>
        <Col>
          <Space>
            <label className={styles.label}>CAS No.:</label>
            <div>{component.cas || '-'}</div>
          </Space>
        </Col>
      </Row>
      <Row className='mt1'>
        <Col>
          <Space>
            <label className={styles.label}>Inchi:</label>
            <div>{component.inchi || '-'}</div>
          </Space>
        </Col>
      </Row>
      <Row className='mt1'>
        <Col>
          <Space>
            <label className={styles.label}>Inchi Key:</label>
            <div>{component.inchiKey || '-'}</div>
          </Space>
        </Col>
      </Row>
    </Modal>
  </>);
})

export default ChemicalComponentDetailModal
